import { call, put, takeEvery } from 'redux-saga/effects';
import { getCountriesApi, getAllCountriesApi } from '../../api/countryApi';
import { COUNTRY_CONSTANT } from '../constants/countryConstants';


function* getCountriesSaga(action) {
  try {
    const response = action.payload.search 
      ? yield call(getCountriesApi, action.payload.search)
      : yield call(getAllCountriesApi);
    yield put({ type: COUNTRY_CONSTANT.GET_COUNTRIES_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: COUNTRY_CONSTANT.GET_COUNTRIES_FAILURE, payload: error.message });
  }
}

export default function* countrySaga() {
  yield takeEvery(COUNTRY_CONSTANT.GET_COUNTRIES_REQUEST, getCountriesSaga);
}